export const ADD_QUESTIONNAIRE = "ADD_QUESTIONNAIRE"
export const EDIT_QUESTIONNAIRE = "EDIT_QUESTIONNAIRE"
export const LIST_QUESTIONNAIRE = "LIST_QUESTIONNAIRE"
export const VIEW_QUESTIONNAIRE = "VIEW_QUESTIONNAIRE"
export const DELETE_QUESTIONNAIRE = "DELETE_QUESTIONNAIRE"

// Text
export const ADD_QUESTIONNAIRE_TEXT = "ADD_QUESTIONNAIRE_TEXT"
export const EDIT_QUESTIONNAIRE_TEXT = "EDIT_QUESTIONNAIRE_TEXT"
export const LIST_QUESTIONNAIRE_TEXT = "LIST_QUESTIONNAIRE_TEXT"
export const VIEW_QUESTIONNAIRE_TEXT = "VIEW_QUESTIONNAIRE_TEXT"
export const DELETE_QUESTIONNAIRE_TEXT = "DELETE_QUESTIONNAIRE_TEXT"

export const QUESTIONNAIRE_SUCCESS = "QUESTIONNAIRE_SUCCESS"
export const QUESTIONNAIRE_ERROR = "QUESTIONNAIRE_ERROR"

